import dataReport from '../network/dataReport.js';
import defaultApi from '../default/index.js';
import NOTICE from '../notice.js';
import { deviceListReport } from './device.js';
import util from '../util/util.js';
import getRTCInstance from 'omnirtc-web';
import * as defaultsdk from './default-sdk.js';
import commonFetch from '../network/commonFetch.js';
import { getTokenServerUrl } from '../config/config.js';
import { globalVariables } from './global-variables.js';
import * as reporter from '../util/reporter.js';


// 扩展标识
const extensionId = 'talrtc_ext';
// 端提供的 API 入口
const EM = window.EM;
// 是否执行过 TALRTC 的 AddListener 的标志
let hasAddListener = false;
// 监听id
let EMListenerId = 0;
// rtc小班课=0；rtc大班课=1
const classType = 0;
// 0: 小组课  1: 小班课  2: 新小班课
let classMode = 0;
// 心跳
let heartBeatDataReportObj = {};
let isFirstHeartBeatReport = false;
// 维护的一份拉流的 streamId 与本地预览通道的映射表
let streamIdToPreviewId = {};
let previewIdToStreamId = {};
let heartBeatDataReportTimer = null;
let streamIdRtcPlayerInfo = {};
let streamIdRtcPlayerInfo1 = {};
// 拉流的播放通道初始化从 0 开始依次递增至44(共45路流)，-1 为推流的本地视频预览
const uiChnIndexs = new Array(100).fill(0).map((a, b) => b).reverse();
// 维护的一份当前正在使用的音频设备的 deviceId 的列表
let usingAudioDeviceId = {
  speaker: '',
  microphone: ''
};
let localStreamId = '';
let screenStreamId = '';
let isPublishing = false;
let isScreenSharing = false;
let isSpeakerCapturing = false;
let sdkVersion = null;
const streamMuteStatus = {};
const localStreamMuteStatus = {
  video: false,
  audio: false,
};
//记录底层推流回调的值
let dataTalrtcCapture = {};
let qualityLocalArr = [];
let qualityRemoteArr = [];
let localRoomId = null;
let userId = null;
let isNoticeMicVolume = false;
let enableLocalCapture = true; // 本地摄像头采集，默认允许
let teacherId = null;
let qualityLocal = 0;
let qualityRemote = 0;
let institutionId = null;
let liveId = null;
let micVolume = 100;
let speakerVolume = 100;

const BUSI_USER_ROLE = {
  student: 0,
  teacher: 1,
  assistant: 2,
};

const SCREEN_CONSTRAINTS = {
  width: { max: 1920 },
  height: { max: 1080 },
  frameRate: 15,
};

class Clients extends Map {
  constructor() {
    super(arguments);
  }
  /**
   * @param {string} roomId
   * @param {import('omnirtc-web').IOmniRTCClient} client
   */
  set(roomId, client) {
    addListener(client);
    return super.set(roomId, client);
  }
  /**
   * 
   * @param {string} roomId 
   * @returns {import('omnirtc-web').IOmniRTCClient | null}
   */
  get(roomId) {
    return super.get(roomId);
  }
  /**
   * 
   * @param {string} roomId 
   * @returns 
   */
  delete(roomId) {
    const client = super.get(roomId);
    if (client) {
      client.leave();
      client.removeAllListeners();
    }
    return super.delete(roomId);
  }
  clear() {
    super.forEach((client) => {
      client.leave();
      client.removeAllListeners();
    });
    return super.clear();
  }
}
class User {
  constructor(subAudio, subVideo, userId) {
    /**
     * @type {boolean}
     */
    this.subAudio = !!subAudio;
    /**
     * @type {boolean}
     */
    this.subVideo = !!subVideo;
    /**
     * @type {boolean}
     */
    this.subScreenAudio = false;
    /**
     * @type {boolean}
     */
    this.subScreenVideo = false;
    /**
     * @type {string}
     */
    this.videoDomId = '';
    /**
     * @type {string}
     */
    this.screenDomId = '';
    /**
     * omnirtc-web 中的 streamId
     * @type {string}
     */
    this.mainStreamId = '';
    /**
     * omnirtc-web 中的 streamId
     * @type {string}
     */
    this.screenStreamId = '';
    /**
     * @type {import('omnirtc-web').IOmniRTCRemoteUser | null}
     */
    this.rtcUser = null;
    /**
     * @type {string}
     */
    this.userId = userId;
  }
}
/**
 * @type {import('omnirtc-web').IOmniRTC | null}
 */
let talrtc = null;

/**
 * @type {import('omnirtc-web').IMicrophoneAudioTrack | null}
 */
let audioCapTrack = null;

/**
 * @type {import('omnirtc-web').ICameraVideoTrack | null}
 */
let videoCapTrack = null;

/**
 * @type {import('omnirtc-web').ILocalVideoTrack | null}
 */
let videoEncTrack = null;

/**
 * @type {import('omnirtc-web').ICameraVideoTrack | null}
 */
let deviceCheckerTrack = null;
let deviceCheckerDomId;

/**
 * @type {import('omnirtc-web').ILocalVideoTrack | null}
 */
let screenVideoTrack = null;
let screenPreviewDomId;

/**
 * @type {import('omnirtc-web').ILocalAudioTrack | null}
 */
let screenAudioTrack = null;

const clients = new Clients();
/**
 * @type {Map<string, User>}
 */
const users = new Map();

/**
 * @type {import('omnirtc-web').VideoEncoderConfiguration}
 */
const videoEncoderConfig = {
  width: 640,
  height: 480,
  frameRate: 15,
  bitrateMax: 500,
};

/**
 * 
 * @param {import('omnirtc-web').IOmniRTC} rtc 
 */
const addDeviceListener = (rtc) => {
  rtc.onCameraChanged = (camera) => onCameraChanged(camera);
  rtc.onMicrophoneChanged = (microphone) => onMicrophoneChanged(microphone);
};
/**
 * 
 * @param {import('omnirtc-web').IOmniRTCClient} client 
 */
const addListener = (client) => {
  client.on('user-joined', (rtcUser) => onUserJoined(client, rtcUser));
  client.on('user-left', (rtcUser) => onUserLeft(client, rtcUser));
  client.on('user-published', (rtcUser, mediaType, streamId) => onUserPublished(client, rtcUser, mediaType, streamId));
  client.on('user-unpublished', (rtcUser, mediaType, streamId) => onUserUnpublished(client, rtcUser, mediaType, streamId));
  client.on('user-info-updated', (uid, info) => onUserInfoUpdated(client, uid, info));
  client.on('volume-indicator', (result) => onVolumeIndicator(client, result));
  client.on('connection-state-change', (state) => {
    reporter.sdkEvent('connection-state-change', { state });
    if (state === 'CONNECTED') {
      startPullQualityInterval(client);
    }
  });
};

/**
 * 用户入会
 * @param {import('omnirtc-web').IOmniRTCClient} client
 * @param {import('omnirtc-web').IOmniRTCRemoteUser} rtcUser 
 */
const onUserJoined = (client, rtcUser) => {
  defaultApi.writeLog(`avsdk TALRTC::onUserJoined ${rtcUser.uid}, audio:${rtcUser.hasAudio} video:${rtcUser.hasVideo}`);
  reporter.sdkEvent('user-joined', { uid: rtcUser.uid, audio: rtcUser.hasAudio, video: rtcUser.hasVideo });
  const key = `${client.channelName}_${rtcUser.uid}`;
  let user = users.get(key);

  if (!user) {
    user = new User();
    users.set(key, user);
  }
  user.rtcUser = rtcUser;
  return user;
};
/**
 * 
 * @param {import('omnirtc-web').IOmniRTCClient} client
 * @param {import('omnirtc-web').IOmniRTCRemoteUser} rtcUser 
 */
const onUserLeft = (client, rtcUser) => {
  defaultApi.writeLog(`avsdk TALRTC::onUserLeft ${rtcUser.uid}`);
  reporter.sdkEvent('user-left', { uid: rtcUser.uid });
  const key = `${client.channelName}_${rtcUser.uid}`;

  const user = users.get(key);

  if (user) {
    user.rtcUser = null;
    user.mainStreamId = '';
    user.screenStreamId = '';

    if (user.userId) {
      NOTICE.rtcUserLeft({
        userId: user.userId,
      });
    }
  }
  // const key = `${client.channelName}_${rtcUser.uid}`;
  // users.delete(key);
};

/**
 * 
 * @param {import('omnirtc-web').IOmniRTCClient} client
 * @param {import('omnirtc-web').IOmniRTCRemoteUser} rtcUser 
 * @param {string} mediaType
 * @param {string} streamId_inner
 */
const onUserPublished = async (client, rtcUser, mediaType, streamId_inner) => {
  defaultApi.writeLog(`avsdk TALRTC::onUserPublished ${rtcUser.uid} ${mediaType} ${streamId_inner}`);
  reporter.sdkEvent('user-published', { uid: rtcUser.uid, audio: rtcUser.hasAudio, video: rtcUser.hasVideo, streamId_inner });
  const [,,,flag] = streamId_inner.split('_');
  const user = onUserJoined(client, rtcUser);
  const streamIdMeta = [institutionId, client.channelName, rtcUser.uid];
  if (flag === 'sub') {
    streamIdMeta.push(liveId);
  }
  streamIdMeta.push('1');
  const streamId = streamIdMeta.join('_');
  defaultApi.writeLog(`avsdk TALRTC::onUserPublished ${user.subAudio} ${user.subVideo}`);

  if (flag === 'main') {
    user.mainStreamId = streamId_inner;
    if (mediaType === 'audio' && user.subAudio) {
      muteRemoteAudio(streamId, false);
    }
    if (mediaType === 'video' && user.subVideo) {
      muteRemoteVideo(streamId, false);
    }
  } else if (flag === 'sub') {
    user.screenStreamId = streamId_inner;
    if (mediaType === 'audio' && user.subScreenAudio) {
      muteRemoteScreenAudio(streamId, false);
    }
    if (mediaType === 'video' && user.subScreenVideo) {
      muteRemoteScreenVideo(streamId, false);
    }
  }

};

/**
 * 
 * @param {import('omnirtc-web').IOmniRTCClient} client
 * @param {import('omnirtc-web').IOmniRTCRemoteUser} rtcUser 
 */
const onUserUnpublished = (client, rtcUser, mediaType) => {
  defaultApi.writeLog(`avsdk TALRTC::onUserUnpublished ${rtcUser.uid} ${mediaType}`);
  reporter.sdkEvent('user-unpublished', { uid: rtcUser.uid, audio: rtcUser.hasAudio, video: rtcUser.hasVideo });
};
const onUserInfoUpdated = (client, uid, info) => {
  defaultApi.writeLog(`avsdk TALRTC::onUserInfoUpdated ${uid} ${JSON.stringify(info)}`);
  reporter.sdkEvent('user-info-updated', { uid, info });
};
const onVolumeIndicator = (client, result) => {};
/**
 * 
 * @param {import('omnirtc-web').DeviceInfo} camera
 */
const onCameraChanged = async (camera) => {
  defaultApi.writeLog(`avsdk TALRTC::onCameraChanged ${JSON.stringify(camera)}`);
  reporter.sdkEvent('camera-changed', { state: camera.state, deviceId: camera.device.deviceId });
  await setCameraDevice({deviceId: camera.state === 'ACTIVE' ? camera.device.deviceId : '', operationType: 'hotPlug', deviceState: camera.state === 'ACTIVE' ? 0 : 1, changedDeviceId: camera.device.deviceId});
};
/**
 * 
 * @param {import('omnirtc-web').DeviceInfo} microphone
 */
const onMicrophoneChanged = async (microphone) => {
  defaultApi.writeLog(`avsdk TALRTC::onMicrophoneChanged ${JSON.stringify(microphone)}`);
  reporter.sdkEvent('microphone-changed', { state: microphone.state, deviceId: microphone.device.deviceId });
  await setMicrophoneDevice({deviceId: microphone.state === 'ACTIVE' ? microphone.device.deviceId : '', operationType: 'hotPlug', deviceState: microphone.state === 'ACTIVE' ? 0 : 1, changedDeviceId: microphone.device.deviceId});
};
/**
 * 
 * @param {import('omnirtc-web').IOmniRTCClient} client
 */
const startPullQualityInterval = (client) => {
  const interval = setInterval(() => {
    if (client.connectionState === 'CONNECTED') {
      const stats = client.getRemoteVideoStats();

      users.forEach((user, key) => {
        if (!user.userId) {
          return;
        }
        const [roomId, userId] = key.split('_');
        const streamId = `${institutionId}_${roomId}_${user.userId}_1`;
        const userStats = stats[userId] || {};
        let volume = 0;
        if (user.rtcUser && user.rtcUser.audioTrack) {
          volume = user.rtcUser.audioTrack.getVolumeLevel() * 100 >> 0;
        }
        NOTICE.pullQuality({
          video: {
            streamId,
            userId: user.userId,
            bitrate: userStats.receiveBitrate >> 0,
            fps: userStats.decodeFrameRate >> 0,
            volume,
          }
        });
      });
    } else if (client.connectionState === 'DISCONNECTED') {
      clearInterval(interval);
    }
  }, 1000);
};
async function getToken(appid, room, user, planid) {
  const querys = {
    appid,
    planid,
    room,
    user: formatUserId(user),
  };
  return commonFetch(getTokenServerUrl() + '/webrtc/xueersitoken', querys, 'GET');
}

/**
 * 
 * @param {string | number} userId 
 * @returns {string}
 */
const formatUserId = (userId) => {
  userId = String(userId);
  const userNumber = userId.match(/\d+/);
  const baseNumber = 1e9;
  if (!userNumber || !userNumber.length) {
    return baseNumber;
  }
  const pureNumber = parseInt(userNumber[0]) || 0;
  if (pureNumber === Number(userId)) {
    return String(pureNumber);
  } else {
    return String(pureNumber + baseNumber);
  }
};
// 初始化相关
const init = async (args) => {
  reporter.sdkProbe('talrtc::init', args);
  defaultApi.writeLog(`avsdk TALRTC::init ${JSON.stringify(args)}`);
  const usedDevices = window.zbztAVSDK_device_checker_init;
  const { devices } = args;
  const sdkType = window.zbztAVSDK_init_sdk_type || 'talrtc';
  localStreamId = args.streamId;
  screenStreamId = `${args.institutionId}_${args.roomId}_${args.userId}_${args.live_id}_1`;
  globalVariables.localStreamId = localStreamId;
  globalVariables.screenStreamId = screenStreamId;
  teacherId = args.teacherId;
  institutionId = args.institutionId;
  liveId = args.live_id;
  const _devices = {
    camera: (devices && devices.camera) || (usedDevices && usedDevices.camera && usedDevices.camera.use) || '',
    microphone: (devices && devices.microphone) || (usedDevices && usedDevices.microphone && usedDevices.microphone.use) || '',
    speaker: (devices && devices.speaker) || (usedDevices && usedDevices.speaker && usedDevices.speaker.use) || ''
  };

  videoEncoderConfig.width = args.encodedResolutionWidth;
  videoEncoderConfig.height = args.encodedResolutionHeight;
  videoEncoderConfig.frameRate = args.encodeCaptureFps;
  videoEncoderConfig.bitrateMax = Math.floor(parseInt(args.encodeCaptureBitrate) / 1000);
  defaultsdk.updateVideoEncoderConfig(videoEncoderConfig);
  const token = await getToken(args.appId, args.roomId, args.userId, args.live_id);
  reporter.sdkProbe('talrtc::getToken', token);
  talrtc = getRTCInstance(token,
    JSON.stringify({accountId: args.userId, header: args.institutionId, liveId: args.live_id, mainStream: localStreamId, role: args.role}),
  );
  talrtc.enableLogUpload();
  // talrtc.setLogLevel(1);
  const client = talrtc.createClient({
    codec: 'h264',
    mode: args.role === 'spy' ? 'live' : 'rtc',
    streamPrefix: institutionId,
  });
  clients.set(String(args.roomId), client);
  talrtc.onAutoplayFailed = (autoResume, kind) => {
    if (kind !== 'video' && client._type === 7) {
      return;
    }
    NOTICE.autoplayFailed();
  };
  defaultApi.writeLog('avsdk TALRTC::init onAutoplayFailed is function? ' + typeof talrtc.onAutoplayFailed);
  reporter.sdkProbe('talrtc::beforeJoin', { roomId: args.roomId, userId: args.userId, role: args.role, sdkType });
  await client.join();

  reporter.sdkProbe('talrtc::join', { roomId: args.roomId });
  if (args.role !== 'spy') {
    try {
      await setDefaultDevice(_devices, 'default');
    } catch (e) {
      reporter.sdkProbe('talrtc::setDefaultDevice', { error: String(e) });
    }
  }

  reporter.sdkProbe('talrtc::setDefaultDevice', _devices);
  setMicphoneVolumInterval(1000);
  startRemoteVolumeInterval(1000);
  addDeviceListener(talrtc);
  // await setMediaSideFlags();
  window.current_sdk_type = sdkType;
  defaultApi.writeLog('avsdk TALRTC::init finished current_sdk_type: ' + sdkType);
  if (client._type === 8) {
    return 'volcrtc';
  } else {
    return 'talrtc';
  }
};

/**
 * @function 销毁引擎
 * @return Promise | void
 */
const destroyEngine = () => {
  defaultApi.writeLog('avsdk TALRTC::destroyEngine');
  if (audioCapTrack) {
    audioCapTrack.stop();
    audioCapTrack.close();
  }

  if (videoCapTrack) {
    videoCapTrack.stop();
    videoCapTrack.close();
  }

  if (videoEncTrack) {
    videoEncTrack.stop();
    videoEncTrack.close();
  }

  if (screenVideoTrack) {
    screenVideoTrack.stop();
    screenVideoTrack.close();
  }

  if (screenAudioTrack) {
    screenAudioTrack.stop();
    screenAudioTrack.close();
  }

  if (deviceCheckerTrack) {
    deviceCheckerTrack.stop();
    deviceCheckerTrack.close();
  }

  if (talrtc) {
    talrtc.onCameraChanged = null;
    talrtc.onMicrophoneChanged = null;
  }
  users.clear();
  clients.clear();
  audioCapTrack = null;
  videoCapTrack = null;
  videoEncTrack = null;
  screenVideoTrack = null;
  screenAudioTrack = null;
  deviceCheckerTrack = null;
};

// 设置采集分辨率
const setCameraCaptureResolution = (width, height, streamId = localStreamId) => {
  return callMethod('SetCameraCaptureResolution', { width, height, streamId });
};

// 设置编码分辨率
const setCameraEncodeResolution = (width, height, streamId = localStreamId) => {
  return callMethod('SetCameraEncodeResolution', { width, height, streamId });
};

// 设置编码帧率
const setCameraEncodeFps = (fps, streamId = localStreamId) => {
  return callMethod('SetCameraEncodeFps', { fps, streamId });
};

// 设置编码码率
const setCameraEncodeBitrate = (bitrate, streamId = localStreamId) => {
  return callMethod('SetCameraEncodeBitrate', { bitrate, streamId });
};

// 获取指定摄像头的支持的分辨率
const getCameraResolution = async (deviceId) => {
  const resp = await callMethod('GetCameraResolution', { deviceId });
  const cameraArr = JSON.parse(resp.msg || '{}').SupportedResolution;
  return {
    code: resp.code,
    msg: JSON.stringify(cameraArr)
  };
};

const setCurrentMicrophoneVolume = async (volume) => {
  if (typeof volume !== 'number' || volume < 0 || volume > 100) {
    defaultApi.writeLog('avsdk TALRTC::setCurrentMicrophoneVolume volume is not a number or less than 0 or greater than 100', null, 'error');
    throw new Error('[setCurrentMicrophoneVolume] volume is not a number or less than 0 or greater than 100');
  }

  defaultApi.writeLog('avsdk TALRTC::setCurrentMicrophoneVolume volume: ' + volume);
  micVolume = volume;

  if (audioCapTrack) {
    audioCapTrack.setVolume(volume);
  }
};

const getCurrentMicrophoneVolume = async () => {
  defaultApi.writeLog('avsdk TALRTC::getCurrentMicrophoneVolume ' + micVolume);
  return micVolume;
};

// 获取 rtc_sdk.dll 版本号
const getSDKVersion = async () => {
  if (sdkVersion) {
    return sdkVersion;
  }
  return callMethod('GetSDKVersion', {}).then((e) => {
    sdkVersion = e;
  });
};

/**
 * @function 设置默认的硬件设备，包括摄像头、麦克风以及扬声器
 * @return Promise
 */
export const setDefaultDevice = async (devices, operationType) => {
  return new Promise(async (resolve, reject) => {
    const timeout = setTimeout(() => {
      reject('setDefaultDevice timeout');
    }, 10e3);
    // 设置默认的摄像头
    if (devices && devices.camera) {
      if (zbztAVSDK_device_checker_init.camera.list.length == 0) {
        await getCameraDeviceList();
      }
      await setCameraDevice({ deviceId: devices.camera, operationType: `${operationType}_1` });
    } else {
      const cameraData = await getCameraDeviceList();
      if (cameraData.length) {
        let hasSetCamera = false;
        for (let item of cameraData) {
          if (item.isDefault) {
            await setCameraDevice({ deviceId: item.deviceId, operationType: `${operationType}_2` });
            hasSetCamera = true;
            break;
          }
        }
        if (!hasSetCamera) {
          await setCameraDevice({ deviceId: cameraData[0].deviceId, operationType: `${operationType}_3` });
        }
      }
    }
    // 设置默认的麦克风
    if (devices && devices.microphone) {
      if (zbztAVSDK_device_checker_init.microphone.list.length == 0) {
        await getMicrophoneDeviceList();
      }
      await setMicrophoneDevice({ deviceId: devices.microphone, operationType: `${operationType}_1` });
    } else {
      const microPhoneData = await getMicrophoneDeviceList();
      try {
        if (microPhoneData.length) {
          let hasSetMicrophone = false;
          for (let item of microPhoneData) {
            if (item.isDefault) {
              await setMicrophoneDevice({ deviceId: item.deviceId, operationType: `${operationType}_2` });
              hasSetMicrophone = true;
              break;
            }
          }
          if (!hasSetMicrophone) {
            await setMicrophoneDevice({ deviceId: microPhoneData[0].deviceId, operationType: `${operationType}_3` });
          }
        }
      } catch (e) {
        console.log(e);
      }

    }
    // 设置默认的扬声器
    if (devices && devices.speaker) {
      await setSpeakerDevice({ deviceId: devices.speaker, operationType: `${operationType}_1` });
    } else {
      const speakerData = await getSpeakerDeviceList();
      if (speakerData.length) {
        let hasSetSpeaker = false;
        for (let item of speakerData) {
          if (item.isDefault) {
            await setSpeakerDevice({ deviceId: item.deviceId, operationType: `${operationType}_2` });
            hasSetSpeaker = true;
            break;
          }
        }
        if (!hasSetSpeaker) {
          await setSpeakerDevice({ deviceId: speakerData[0].deviceId, operationType: `${operationType}_3` });
        }
      }
    }
    clearTimeout(timeout);
    resolve();
  });
};

// 麦克风相关
/**
 * @function 开启麦克风
 * @param intervalMs: Number
 * @return Promise | void
 */
const startMicrophone = async (intervalMs = 500) => {
  defaultApi.writeLog('avsdk TALRTC::startMicrophone');
  isNoticeMicVolume = true;
  audioCapTrack = await talrtc.createMicrophoneAudioTrack({
    microphoneId: window.zbztAVSDK_device_checker_init.microphone.use,
    AEC: true,
    ANS: true,
    AGC: true,
  });

  audioCapTrack.on('track-ended', () => {
    defaultApi.writeLog('avsdk TALRTC::startMicrophone track-ended');
    // audioTrack.removeAllListeners();
    // audioTrack = null;
  });

  audioCapTrack.setVolume(micVolume);

  if (isPublishing) {
    startPushLocalStream('audio');
  }
};

/**
 * @function 关闭麦克风
 * @return Promise | void
 */
const stopMicrophone = async () => {
  defaultApi.writeLog('avsdk TALRTC::stopMicrophone');
  isNoticeMicVolume = false;
  if (audioCapTrack) {
    audioCapTrack.stop();
    audioCapTrack.close();
  }

  if (isPublishing) {
    stopPushLocalStream('audio');
  }
};

const openOrCloseMicrophone = async (operation) => {
  if (operation) {
    await startMicrophone();
  } else {
    await stopMicrophone();
  }
};

let micVolTimer;
/**
 * @function 设置麦克风音量大小回调周期
 * @param intervalMs: Number
 * @return Promise | void
 */
const setMicphoneVolumInterval = (intervalMs = 1000) => {
  if (typeof intervalMs !== 'number' || intervalMs < 0) {
    defaultApi.writeLog('avsdk TALRTC::setMicphoneVolumInterval intervalMs is not a number or less than 0', null, 'error');
    throw new Error('[setMicphoneVolumInterval] intervalMs is not a number or less than 0');
  }
  micVolTimer = setInterval(async () => {
    if (audioCapTrack) {
      const volume = audioCapTrack.getVolumeLevel() * 100;
      NOTICE.captureMicVolumeChanged({
        volume: Math.round(volume)
      });
      heartBeatDataReportObj.volume = heartBeatDataReportObj.volume + Math.round(volume) + ',';
    }
  }, intervalMs);
};

let remoteVolTimer;
const startRemoteVolumeInterval = (intervalMs = 1000) => {
  remoteVolTimer = setInterval(async () => {
    users.forEach((user, key) => {
      if (user.rtcUser && user.rtcUser.hasAudio && user.rtcUser.audioTrack) {
        const [roomId] = key.split('_');
        const volume = user.rtcUser.audioTrack.getVolumeLevel() * 100;
        const cbData = {
          streamid: `${institutionId}_${roomId}_${user.userId}_1`,
          userId: user.userId,
          volume: Math.round(volume)
        };

        NOTICE.playerVolumeChanged(cbData);
        NOTICE.volumeChange(cbData);
      }
    });
  }, intervalMs);
};

/**
 * @function 获取麦克风列表
 * @return Promise | void
 */
const getMicrophoneDeviceList = async () => {
  defaultApi.writeLog('avsdk TALRTC::getMicrophoneDeviceList');
  return defaultsdk.getMicrophoneDeviceList();
};

/**
 * @function 指定麦克风设备
 * @param deviceId: String 麦克风设备 id，必选
 * @param operationType: String 操作类型，可选
 * @return Promise | void
 */
const setMicrophoneDevice = async (args) => {
  defaultApi.writeLog('-> getMicrophoneDeviceList_microphoneListArr_tal_rtc_i');
  let { deviceId, operationType, deviceState, changedDeviceId } = args;
  let deviceName = '';
  let microPhoneData;
  if (!deviceId) {
    microPhoneData = await getMicrophoneDeviceList();
    if (microPhoneData.length) {
      let hasGetMicrophone = false;
      for (let item of microPhoneData) {
        if (item.isDefault) {
          deviceId = item.deviceId;
          deviceName = item.deviceName;
          hasGetMicrophone = true;
          break;
        }
      }
      if (!hasGetMicrophone) {
        deviceId = microPhoneData[0].deviceId;
        deviceName = microPhoneData[0].deviceName;
      }
    } else {
      deviceId = '';
    }
    if (deviceId === '') {
      NOTICE.noDevice({
        deviceType: 'microphone'
      });
    }
  }

  window.zbztAVSDK_device_checker_init.microphone.use = deviceId;
  window.zbztAVSDK_device_checker_init.microphone.name = deviceListReport.micList[deviceId];

  try {
    dataReport.setDevice({
      device_type: 2,
      device_id: deviceId,
      device_name: deviceListReport.micList[deviceId],
      operationType,
      fore_state: operationType == 'hotPlug' ? +deviceState + 1 : '-'
    });
  } catch (e) {
  };
  if (audioCapTrack && audioCapTrack.setDevice) {
    audioCapTrack.setDevice(deviceId);
  }

  defaultsdk.setMicrophoneDevice({deviceId});
  if (operationType == 'hotPlug' || operationType == 'deviceError') {
    if (!microPhoneData) {
      microPhoneData = await getMicrophoneDeviceList();
      deviceName = deviceListReport.micList[deviceId];
    }
    NOTICE[operationType]({
      deviceType: 'microphone',
      useDeviceId: deviceId,
      useDeviceName: deviceName,
      deviceList: microPhoneData,
      deviceState,
      changedDeviceId
    });
  }
};

const updateVideoEncTrack = async () => {
  if (!videoCapTrack) {
    return;
  }
  if (videoEncTrack) {
    await stopPushLocalStream('video');
    videoEncTrack.stop();
    videoEncTrack.close();
    videoEncTrack = null;
  }
  videoEncTrack = talrtc.createCustomVideoTrack({
    mediaStreamTrack: videoCapTrack.getMediaStreamTrack(),
  });

  if (globalVariables.localPreviewDomId) {
    videoEncTrack.play(globalVariables.localPreviewDomId, { fit: 'contain' });
  }

  if (isPublishing) {
    await startPushLocalStream('video');
  }
};

// 摄像头相关
/**
 * @function 打开摄像头
 * @param width: Number
 * @param height: Number
 * @return Promise | void
 */
const startCamera = async (width, height) => {
  defaultApi.writeLog('avsdk TALRTC::startCamera');
  videoCapTrack = await defaultsdk.startCamera();

  await updateVideoEncTrack();
};

/**
 * @function 关闭摄像头
 * @return Promise | void
 */
const stopCamera = async () => {
  defaultApi.writeLog('avsdk TALRTC::stopCamera');
  defaultsdk.stopCamera();
  if (videoCapTrack) {
    videoCapTrack = null;
  }

  if (isPublishing) {
    await stopPushLocalStream('video');
  }
};

const openOrCloseCamera = async (operation) => {
  if (operation) {
    await startCamera();
  } else {
    stopCamera();
  }
};

/**
 * @function 获取摄像头列表
 * @return Promise | void
 */
const getCameraDeviceListInternal = () => {
  return callMethod('GetCameraDeviceList', {});
};

/**
 * @function 获取摄像头列表
 * @return Promise | void
 */
export const getCameraDeviceList = async () => {
  defaultApi.writeLog('avsdk TALRTC::getCameraDeviceList');
  return defaultsdk.getCameraDeviceList();
};

/**
 * @function 设置指定视频（当前摄像头）设备
 * @param deviceId: String 视频设备 id，必选
 * @return Promise | void
 */
const setCurrentCameraDeviceInternal = (deviceId) => {
  window.zbztAVSDK_device_checker_init.camera.use = deviceId;
  return callMethod('SetCurrentCameraDevice', {
    streamId: localStreamId,
    deviceId
  });
};

/**
 * @function 指定使用的摄像头
 * @param deviceId: String 摄像头 id，必选
 * @param operationType: String 操作类型，可选
 * 'device_error' -> 设备出错处理，'plug_and_unplug' -> 热插拔处理，
 * 不传即是普通的设置摄像头设备的行为
 * @return Promise | void
 */
const setCameraDevice = async (args) => {
  defaultApi.writeLog(`setCameraDevice ${JSON.stringify(args)}`);
  let { deviceId, operationType, deviceState, code, changedDeviceId } = args;

  let deviceName = '';
  let cameraData;
  if (!deviceId) {
    cameraData = await getCameraDeviceList();

    if (cameraData.length) {
      let hasGetCamare = false;
      for (let item of cameraData) {
        if (item.isDefault) {
          deviceId = item.deviceId;
          deviceName = item.deviceName;
          hasGetCamare = true;
          break;
        }
      }
      if (!hasGetCamare) {
        deviceId = cameraData[0].deviceId;
        deviceName = cameraData[0].deviceName;
      }
    } else {
      deviceId = '';
    }

    if (deviceId === '') {
      NOTICE.noDevice({
        deviceType: 'camera'
      });
    }
  }

  window.zbztAVSDK_device_checker_init.camera.use = deviceId;
  window.zbztAVSDK_device_checker_init.camera.name = deviceListReport.cameraList[deviceId];
  try {
    dataReport.setDevice({
      device_type: 1,
      device_id: deviceId,
      device_name: deviceListReport.cameraList[deviceId],
      operationType,
      fore_state: operationType == 'hotPlug' ? deviceState + 1 : '-'
    });
  } catch (e) {
  };

  videoCapTrack = await defaultsdk.setCameraDevice({deviceId});
  if (videoCapTrack) {
    updateVideoEncTrack();
  }
  if (operationType == 'hotPlug' || operationType == 'deviceError') {
    if (!cameraData) {
      cameraData = await getCameraDeviceList();
      deviceName = deviceListReport.cameraList[deviceId];
    }
    NOTICE[operationType]({
      deviceType: 'camera',
      useDeviceId: deviceId,
      useDeviceName: deviceName,
      deviceList: cameraData,
      messge: code,
      deviceState,
      changedDeviceId
    });
  }
  try {
    NOTICE.useredCamera({
      deviceId,
      deviceName
    });
  } catch (e) {
  };
};

/**
 * @function 获取当前摄像头 id
 * @return Promise | void
 */
const GetCurrentCameraId = () => {
  return callMethod('GetCurrentCameraId', {});
};

// 扬声器相关

/**
 * @function 获取扬声器列表
 * @return Promise | void
 */
const getAudioDeviceList = () => {
  return callMethod('GetAudioDeviceList', {});
};

/**
 * @function 获取系统默认的音频设备
 * @param deviceType: Number 音频设备类型，0 -> 麦克风，1 -> 扬声器，必选
 * @return Promise | void
 */
const getDefaultAudioDeviceId = (deviceType) => {
  return callMethod('GetDefaultAudioDeviceId', {
    deviceType,
    // 以下两个参数仅仅是为了向下向后兼容，使用 hardcore 即可
    deviceId: '',
    deviceIdLength: 0
  });
};

/**
 * @function 获取系统默认的麦克风设备 id
 * @return Promise
 */
const getDefaultMicrophone = () => {
  return getDefaultAudioDeviceId(0);
};

/**
 * @function 获取系统默认的扬声器设备 id
 * @return Promise
 */
const getDefaultSpeaker = () => {
  return getDefaultAudioDeviceId(1);
};

/**
 * @function 获取扬声器设备列表
 * @return Promise | void
 */
const getSpeakerDeviceListInternal = () => {
  return callMethod('GetSpeakerDeviceList', {});
};

/**
 * @function 获取扬声器列表
 * @return Promise | void
 */
const getSpeakerDeviceList = async () => {
  defaultApi.writeLog('avsdk TALRTC::getSpeakerDeviceList');
  return defaultsdk.getSpeakerDeviceList();
  // const defaultSpeakerId = JSON.parse((await getDefaultSpeaker()).msg).deviceId;
  // const resp = await getSpeakerDeviceListInternal();
  // let speakerListArr = JSON.parse(JSON.parse(resp.msg).DeviceList) || [];
  // let speakerList = [];
  // for (let i = 0, len = speakerListArr.length; i < len; i++) {
  //   speakerList.push({
  //     deviceId: speakerListArr[i].id,
  //     deviceName: speakerListArr[i].name,
  //     isDefault: defaultSpeakerId === speakerListArr[i].id
  //   });
  //   deviceListReport.speakerList[speakerListArr[i].szDeviceId] = speakerListArr[i].szDeviceName;
  // }
  // if (!window.zbztAVSDK_device_checker_init) {
  //   window.zbztAVSDK_device_checker_init = {};
  // }
  // if (!window.zbztAVSDK_device_checker_init.speaker) {
  //   window.zbztAVSDK_device_checker_init.speaker = {};
  // }
  // window.zbztAVSDK_device_checker_init.speaker.hasTest = true;
  // window.zbztAVSDK_device_checker_init.speaker.list = speakerList;
  // return speakerList;
};

/**
 * @function 设置指定音频（当前扬声器）设备
 * @param deviceId: String 音频设备 id，必选
 * @return Promise | void
 */
const setCurrentSpeakerDevice = (deviceId) => {
  window.zbztAVSDK_device_checker_init.speaker.use = deviceId;
  return callMethod('SetCurrentSpeakerDevice', {
    deviceId
  }).then((result) => {
    if (result.code === 0) {
      NOTICE.speakerChanged({
        deviceId
      });
    }
    return result;
  });
};

/**
 * 获取当前扬声器设备id
 * @return {String} 当前扬声器设备id
 */
const getCurrentSpeakerDevice = () => {
  defaultApi.writeLog(`avsdk TALRTC::getSpeakerDevice ${usingAudioDeviceId.speaker}`);
  return usingAudioDeviceId.speaker;
};

/**
 * @function 指定扬声器
 * @param deviceId: String 扬声器 id，必选
 * @param operationType:String 操作类型，可选
 * 'device_error' -> 设备出错处理，'plug_and_unplug' -> 热插拔处理，
 * 不传即是普通的设置扬声器设备的行为
 * @return Promise | void
 */
const setSpeakerDevice = async (args) => {
  defaultApi.writeLog(`${JSON.stringify(args)}----setSpeakerDevice-talrtc----`);
  let { deviceId, operationType, deviceState, code, changedDeviceId } = args;
  let deviceName = '';
  let speakerData;
  if (!deviceId) {
    speakerData = await getSpeakerDeviceList();
    if (speakerData.length) {
      let hasGetSpeaker = false;
      for (let item of speakerData) {
        if (item.isDefault) {
          deviceId = item.deviceId;
          deviceName = item.deviceName;
          hasGetSpeaker = true;
          break;
        }
      }
      if (!hasGetSpeaker) {
        deviceId = speakerData[0].deviceId;
        deviceName = speakerData[0].deviceName;
      }
    } else {
      deviceId = '';
    }
    if (deviceId === '') {
      NOTICE.noDevice({
        deviceType: 'speaker'
      });
    }
  }

  window.zbztAVSDK_device_checker_init.speaker.use = deviceId;
  window.zbztAVSDK_device_checker_init.speaker.name = deviceListReport.speakerList[deviceId];

  try {
    dataReport.setDevice({
      device_type: 3,
      device_id: deviceId,
      device_name: deviceListReport.speakerList[deviceId],
      operationType,
      fore_state: operationType == 'hotPlug' ? deviceState + 1 : '-'
    });
  } catch (e) {
    console.log(e);
  };
  usingAudioDeviceId.speaker = deviceId;
  // await setCurrentSpeakerDevice(deviceId);
  if (operationType == 'hotPlug' || operationType == 'deviceError') {
    if (!speakerData) {
      speakerData = await getSpeakerDeviceList();
      deviceName = deviceListReport.speakerList[deviceId];
    }
    NOTICE[operationType]({
      deviceType: 'speaker',
      useDeviceId: deviceId,
      useDeviceName: deviceName,
      deviceList: speakerData,
      message: code,
      deviceState,
      changedDeviceId
    });
  }
};

/**
 * @function 获取当前扬声器ID
 * @return Promise | void
 */
const getCurrentSpeakerId = () => {
  return callMethod('GetCurrentSpeakerId', {});
};

/**
 * @function 是否存在媒体流
 * @param streamId
 * @returns {boolean}
 */
export const hasStream = streamId => {
  return Object.keys(streamIdToPreviewId).includes(streamId);
};


/**
 * @function 获取当前视频流的通道
 * @param  streamId 流 id
 * @return channelIndex
 */
export const getChannelIndex = (streamId) => {
  defaultApi.writeLog(`avsdk TALRTC::getChannelIndex streamId: ${streamId} ${JSON.stringify(streamIdToPreviewId)}`);
  return streamIdToPreviewId[streamId];
};

/**
 * @function 获取当前视频流所有的通道
 * @param  streamId 流 id
 * @return channelIndex
 */
export const getAllChannelIndex = () => {
  defaultApi.writeLog(`avsdk TALRTC::getAllChannelIndex ${JSON.stringify(streamIdToPreviewId)}`);
  return streamIdToPreviewId;
};


/**
 * @function 设置当前扬声器音量
 * @param volume: number 音量值
 * @return Promise | void
 */
const setCurrentSpeakerVolume = (volume) => {
  if (typeof volume !== 'number' || volume < 0 || volume > 100) {
    defaultApi.writeLog('avsdk TALRTC::setCurrentSpeakerVolume volume is not a number or less than 0 or greater than 100', null, 'error');
    throw new Error('[setCurrentSpeakerVolume] volume is not a number or less than 0 or greater than 100');
  }
  defaultApi.writeLog(`avsdk TALRTC::setCurrentSpeakerVolume volume: ${volume}`);
  speakerVolume = volume;
  users.forEach((user) => {
    user.rtcUser && user.rtcUser.audioTrack && user.rtcUser.audioTrack.setVolume(volume);
  });
};
/**
 * @function 获取当前扬声器的音量
 * @returns {Promise<number>}
 */
const getCurrentSpeakerVolume = () => {
  defaultApi.writeLog(`avsdk TALRTC::getCurrentSpeakerVolume ${speakerVolume}`);
  return speakerVolume;
};
/**
 * @function 设置扬声器静音
 * @param mute: Boolean 必选
 * @return Promise | void
 */
const setSpeakerDeviceMute = (mute) => {
  return callMethod('SetSpeakerDeviceMute', {
    deviceId: usingAudioDeviceId.speaker,
    mute
  });
};

/**
 * @function 获取当前应用程序音量
 * @return Promise | void
 */
const getSpeakerSimpleVolume = () => {
  return callMethod('GetSpeakerSimpleVolume', {
    deviceId: usingAudioDeviceId.speaker
  }).then(ret => {
    let volume = 0;
    try {
      volume = Math.round(JSON.parse(ret.msg).speakerVolume / 255 * 100);
    } catch (e) {
      console.error(`zbzt-live-sdk: getSpeakerSimpleVolume ret: ${ret}. error: ${e}`);
    }
    return volume;
  });
};

/**
 * @function 设置当前应用程序音量
 * @param volume: Number 应用程序音量，必选
 * @return Promise | void
 */
const setSpeakerSimpleVolume = (volume) => {
  return callMethod('SetSpeakerSimpleVolume', {
    deviceId: usingAudioDeviceId.speaker,
    volume: Math.round(volume / 100 * 255)
  });
};

/**
 * @function 设置当前应用程序静音
 * @param mute: Boolean 是否静音，必选
 * @return Promise | void
 */
const setSpeakerSimpleMute = (mute) => {
  return callMethod('SetSpeakerSimpleMute', {
    deviceId: usingAudioDeviceId.speaker,
    mute
  });
};

const enableAudioSpeakerCapture = (capture) => {
  setSystemAudioLoopback(capture);
};

/**
 * @function 打开系统声音采集
 * @enable true|false
 * @return Promise | void
 */
const setSystemAudioLoopback = (enable) => {
  isSpeakerCapturing = enable;
  if (enable) {
    return setAudioType(6, localStreamId);
  } else {
    return setAudioType(1, localStreamId);
  }
  // return callMethod('SetAudioSpeakerCapture', {
  //   enable,
  // });
};

/**
 * @function 录制转推对外接口
 * @param type: String start/stop 必选
 * @param targetUrl: String 转推地址(支持 RTMP) 必选
 * @return Promise | void
 */
const controlCdnStreaming = async (type) => {
  const targetUrl = 'rtmp://media-push-ali-test.livecloud.eaydu.com/testlive/210926-11?key=75c868672113df0063430e9e47fb2a60&appId=zt10001&bizId=zt10001AI&cdn=1';
  defaultApi.writeLog(`avsdk TALRTC::controlCdnStreaming targetUrl: ${targetUrl} type: ${type}`);
  if (type === 'start') {
    return addPublishRtmpStreamUrl(targetUrl);
  }
  if (type === 'stop') {
    return removePublishStreamUrl(targetUrl);
  }
};

/**
 * @function SEI 消息
 * @param data: String    数据
 * @param dataSize: Number    数据长度
 * @param repeatCount: Number    重试次数
 * @return Promise | void
 */
const sendSEIMsg = (data) => {
  return callMethod('SendSEIMsg', { data: data, dataSize: data.length, repeatCount: 3 });
};

/**
 * @function 开始屏幕采集
 * @return Promise | void
 */
const startScreenCapture = async () => {
  defaultApi.writeLog('avsdk TALRTC::startScreenCapture');

  const tracks = await talrtc.createScreenVideoTrack({
    encoderConfig: {
      width: SCREEN_CONSTRAINTS.width,
      height: SCREEN_CONSTRAINTS.height,
      frameRate: SCREEN_CONSTRAINTS.frameRate,
    },
    options: {
      preferCurrentTab: false,
      selfBrowserSurface: 'include',
    }
  }, 'enable');

  if (!tracks) {
    defaultApi.writeLog('avsdk TALRTC::startScreenCapture - tracks is null', null, 'error');
    NOTICE.screenShareEnded();
    throw new Error('avsdk TALRTC::startScreenCapture - tracks is null');
  }

  if (Array.isArray(tracks)) {
    defaultApi.writeLog('avsdk TALRTC::startScreenCapture - tracks length: ' + tracks.length);
    tracks.forEach((track) => {
      if (track.getMediaStreamTrack().kind === 'video') {
        screenVideoTrack = track;
      } else if (track.getMediaStreamTrack().kind === 'audio') {
        screenAudioTrack = track;
      }
    });
  } else if (tracks.getMediaStreamTrack()) {
    defaultApi.writeLog('avsdk TALRTC::startScreenCapture - single track');
    const track = tracks.getMediaStreamTrack();
    if (track.kind === 'video') {
      screenVideoTrack = tracks;
    } else if (track.kind === 'audio') {
      screenAudioTrack = tracks;
    }
  }

  if (screenVideoTrack) {
    screenVideoTrack.on('track-ended', () => {
      defaultApi.writeLog('avsdk TALRTC::startScreenCapture track-ended');
      screenVideoTrack.removeAllListeners();
      screenVideoTrack = null;
      NOTICE.screenShareEnded();
    });
  }
};

const restartCaptureScreen = async () => {
  defaultApi.writeLog('avsdk TALRTC::restartCaptureScreen');

  if (!screenVideoTrack) {
    defaultApi.writeLog('avsdk TALRTC::restartCaptureScreen - screenTrack is not exist', null, 'error');
    return;
  }
  
  screenVideoTrack.removeAllListeners();
  await startScreenCapture();

  if (screenPreviewDomId) {
    screenVideoTrack.play(screenPreviewDomId, { fit: 'contain' });
  }
};

const getScreenType = async () => {
  defaultApi.writeLog('avsdk TALRTC::getScreenType');

  if (!screenVideoTrack) {
    defaultApi.writeLog('avsdk TALRTC::getScreenType - screenTrack is not exist', null, 'error');
    return null;
  }

  const track = screenVideoTrack.getMediaStreamTrack();
  return util.getScreenTypeByTrack(track);
};
/**
 * @function 停止屏幕采集
 * @return Promise | void
 */
const stopScreenCapture = () => {
  defaultApi.writeLog('avsdk TALRTC::stopScreenCapture');
  screenVideoTrack && screenVideoTrack.close();
  screenAudioTrack && screenAudioTrack.close();
};

const startDeviceCheckerPreview = async (streamId, domId) => {
  defaultApi.writeLog(`avsdk TALRTC::startDeviceCheckerPreview -- streamId: ${streamId}, domId: ${domId}`);

  if (!domId) {
    defaultApi.writeLog('avsdk TALRTC::startDeviceCheckerPreview - domId is required', null, 'error');
    throw new Error('avsdk TALRTC::startDeviceCheckerPreview - domId is required');
  }

  if (!streamId) {
    defaultApi.writeLog('avsdk TALRTC::startDeviceCheckerPreview - streamId is required', null, 'error');
    throw new Error('avsdk TALRTC::startDeviceCheckerPreview - streamId is required');
  }

  deviceCheckerDomId = domId;
  let capTrack;
  if (streamId === localStreamId) {
    capTrack = videoEncTrack;
  } else if (streamId === screenStreamId) {
    capTrack = screenVideoTrack;
  } else {
    defaultApi.writeLog('avsdk TALRTC::startDeviceCheckerPreview - wrong streamId', null, 'error');
    throw new Error('avsdk TALRTC::startDeviceCheckerPreview - wrong streamId');  
  }

  if (!capTrack) {
    defaultApi.writeLog('avsdk TALRTC::startDeviceCheckerPreview - not start camera yet', null, 'error');
    throw new Error('avsdk TALRTC::startDeviceCheckerPreview - capTrack is not exist');
  }

  deviceCheckerTrack = talrtc.createCustomVideoTrack({
    mediaStreamTrack: capTrack.getMediaStreamTrack(),
  });

  deviceCheckerTrack.play(domId, { fit: 'contain' });
};

const stopDeviceCheckerPreview = () => {
  defaultApi.writeLog('avsdk TALRTC::stopDeviceCheckerPreview');
  deviceCheckerDomId = null;
  deviceCheckerTrack && deviceCheckerTrack.stop();
  deviceCheckerTrack && deviceCheckerTrack.close();
};

// 推拉流相关
/**
 * @function 开启本地或者远程的视频视图
 * @param isLocal: Boolean 是否是本地的视频预览，必选
 * @param streamId: String 要拉取的视频流的 id，可选，只有拉取远程的视频流的时候才是必选的
 * @param domId: String <video> 标签的 id，可选
 * 如果传了 domId，就把视频绑定到对应的 <video> 标签上
 * @return Promise 可从 Promise 中获取 src，Promise.then((src) => {})
 */
const startLocalOrRemotePreview = async (isLocal, streamId, domId) => {
  defaultApi.writeLog(`avsdk TALRTC::startLocalOrRemotePreview streamId: ${streamId}, isLocal: ${isLocal}, domId: ${domId}`);

  if (isLocal) {
    defaultApi.writeLog(`avsdk TALRTC::startLocalOrRemotePreview - localStreamId: ${localStreamId}, videoTrack: ${videoEncTrack}`);
    if (streamId === localStreamId) {
      globalVariables.localPreviewDomId = domId;
      if (videoEncTrack) {
        videoEncTrack.play(domId, { fit: 'contain' });
      }
    }

    if (streamId === screenStreamId) {
      screenPreviewDomId = domId;
      if (!screenVideoTrack) {
        await startScreenCapture();
      }
      screenVideoTrack.play(domId, { fit: 'contain' });
    }

  } else {
    if (!streamId || !domId) {
      defaultApi.writeLog('avsdk TALRTC::startLocalOrRemotePreview - streamId and domId is required', null, 'error');
      return;
    }

    const [, roomId, userId, liveId] = streamId.split('_');
    const user = users.get(`${roomId}_${formatUserId(userId)}`);
    if (!user) {
      defaultApi.writeLog(`avsdk TALRTC::startLocalOrRemotePreview - user:${userId} not found.`);
      return;
    }

    if (liveId === '1') {
      // 主流播放
      user.videoDomId = domId;
      if (user.rtcUser && user.rtcUser.videoTrack) {
        user.rtcUser.videoTrack.play(domId, { fit: 'contain' });
      }
    } else {
      // 屏幕流播放
      user.screenDomId = domId;
      if (user.rtcUser && user.rtcUser.screenTrack) {
        user.rtcUser.screenTrack.play(domId, { fit: 'contain' });
      }
    }
  }
};

/**
 * 
 * @param {'audio' | 'video' | 'both'} type 
 */
const startPushLocalStream = async (type) => {
  defaultApi.writeLog(`avsdk TALRTC::startPushLocalStream ${type}`);
  
  const roomId = util.getRoomIdByStreamId(localStreamId);
  const client = clients.get(roomId);

  if (!client) {
    defaultApi.writeLog('avsdk TALRTC::startPushLocalStream - init first', null, 'error');
    reporter.sdkProbe('talrtc::startPushLocalStream', 'no client');
    throw new Error('avsdk TALRTC::startPushLocalStream - init first');
  }

  const tracks = [];
  if ((type === 'both' || type === 'audio') && audioCapTrack) {
    tracks.push(audioCapTrack);
  }
  if ((type === 'both' || type === 'video') && videoEncTrack) {
    tracks.push(videoEncTrack);
  }
  await client.publish(tracks);
};
/**
 * @param {'audio' | 'video' | 'both'} type 
 */
const stopPushLocalStream = async (type) => {
  defaultApi.writeLog(`avsdk TALRTC::stopPushLocalStream ${type}`);
  const roomId = util.getRoomIdByStreamId(localStreamId);
  const client = clients.get(roomId);

  if (!client) {
    defaultApi.writeLog('avsdk TALRTC::stopPushLocalStream - init first', null, 'error');
    throw new Error('avsdk TALRTC::stopPushLocalStream - init first');
  }

  const tracks = [];
  if ((type === 'both' || type === 'audio') && audioCapTrack) {
    tracks.push(audioCapTrack);
  }
  if ((type === 'both' || type === 'video') && videoEncTrack) {
    tracks.push(videoEncTrack);
  }
  await client.unpublish(tracks);
};

const startPushScreenStream = async () => {
  defaultApi.writeLog('avsdk TALRTC::startPushScreenStream');
  const roomId = util.getRoomIdByStreamId(screenStreamId);
  const client = clients.get(roomId);

  if (!client) {
    defaultApi.writeLog('avsdk TALRTC::startPushScreenStream - init first', null, 'error');
    reporter.sdkProbe('talrtc::startPushScreenStream', 'no client');
    throw new Error('avsdk TALRTC::startPushScreenStream - init first');
  }

  const tracks = [];

  if (screenVideoTrack) {
    tracks.push(screenVideoTrack);
  }
  if (screenAudioTrack) {
    tracks.push(screenAudioTrack);
  }

  defaultApi.writeLog('avsdk TALRTC::startPushScreenStream - end. ' + tracks.length);
  await client.publish(tracks);
};
const stopPushScreenStream = async () => {
  defaultApi.writeLog('avsdk TALRTC::stopPushScreenStream');
  const roomId = util.getRoomIdByStreamId(screenStreamId);
  const client = clients.get(roomId);

  if (!client) {
    defaultApi.writeLog('avsdk TALRTC::stopPushScreenStream - init first', null, 'error');
    throw new Error('avsdk TALRTC::stopPushScreenStream - init first');
  }

  const tracks = [];

  if (screenVideoTrack) {
    tracks.push(screenVideoTrack);
  }

  if (screenAudioTrack) {
    tracks.push(screenAudioTrack);
  }

  defaultApi.writeLog('avsdk TALRTC::stopPushScreenStream - end. ' + tracks.length);
  await client.unpublish(tracks);
};
/**
 * @function 开始推流
 * @param streamId: String   流 id
 * @return Promise | void
 */
const startPush = async (streamId) => {
  if (!streamId) {
    streamId = localStreamId;
  }
  defaultApi.writeLog(`avsdk TALRTC::startPush streamId: ${streamId}`);

  try {
    if (!isFirstHeartBeatReport) {
      isFirstHeartBeatReport = true;
      heartBeatDataReport('start');
    }
  } catch (error) {}

  if (streamId === screenStreamId) {
    await startScreenCapture();
    await startPushScreenStream();
    isScreenSharing = true;
  }

  if (streamId === localStreamId) {
    await startPushLocalStream('both');
    isPublishing = true;
  }

  NOTICE.pushFlowSuccess({
    code: 0,
    publish_streamid: streamId,
  });
};

/**
 * @function 停止推流
 * @param streamId: String   流 id
 * @return Promise | void
 */
const stopPush = async (streamId) => {
  if (!streamId) {
    streamId = localStreamId;
  }

  defaultApi.writeLog(`avsdk TALRTC::stopPush streamId: ${streamId}`);

  if (streamId === screenStreamId && screenVideoTrack) {
    screenVideoTrack.close();
    await stopPushScreenStream();
    isScreenSharing = false;
    screenVideoTrack = null;
  }

  if (streamId === localStreamId) {
    await stopPushLocalStream('both');
    isPublishing = false;
  }
};

/**
 * @function 不推/推 音频
 * @param mute: bool
 * @return Promise | void
 */
const muteLocalAudio = async (mute) => {
  defaultApi.writeLog(`avsdk TALRTC::muteLocalAudio mute: ${mute}`);

  if (audioCapTrack) {
    await audioCapTrack.setMuted(mute);
  }
  localStreamMuteStatus.audio = mute;
};

/**
 * @function 不推/推 视频
 * @param mute: bool
 * @return Promise | void
 */
const muteLocalVideo = async (mute) => {
  defaultApi.writeLog(`avsdk TALRTC::muteLocalVideo mute: ${mute}`);

  if (videoEncTrack) {
    await videoEncTrack.setMuted(mute);
  }
  localStreamMuteStatus.video = mute;
};

/**
 * @function 开始转推本地摄像头 TALRTC 流至 RTMP。目前只支持转推 1 路
 * @return Promise | void
 */
const addPublishRtmpStreamUrl = (url) => {
  defaultApi.writeLog(`avsdk TALRTC::addPublishRtmpStreamUrl url: ${url}`);
  return callMethod('AddPublishRtmpStreamUrl', { url });
};

/**
 * @function 停止转推 RTMP
 * @return Promise | void
 */
const removePublishStreamUrl = (url) => {
  defaultApi.writeLog(`avsdk TALRTC::removePublishStreamUrl url: ${url}`);
  return callMethod('RemovePublishStreamUrl', { url });
};

/**
 * @function 开始拉流
 * @param {string} streamId   流 id
 * @return {Promise} Promise | void
 */
const startPlay = async (streamId, muteAudio, muteVideo) => {
  if (!muteAudio) {
    if (streamId.split('_').length === 4) {
      await muteRemoteAudio(streamId, false);
    } else {
      await muteRemoteScreenAudio(streamId, false);
    }
  }
  if (!muteVideo) {
    if (streamId.split('_').length === 4) {
      await muteRemoteVideo(streamId, false);
    } else {
      await muteRemoteScreenVideo(streamId, false);
    }
  }
};
/**
 * @function 停止拉流
 * @param streamId: String 流 id
 * @return Promise | void
 */
const stopPlay = async (streamId) => {
  defaultApi.writeLog(`avsdk TALRTC::stopPlay streamId: ${streamId}`);
  if (streamId.split('_').length === 4) {
    await muteRemoteAudio(streamId, true);
    await muteRemoteVideo(streamId, true);
  } else {
    await muteRemoteScreenAudio(streamId, true);
    await muteRemoteScreenVideo(streamId, true);
  }
};
/**
 * @function 初始化拉流
 * @param streamId:String 从传来的信道消息中获取，必选
 * @param domId:String <video> 标签的 id，可选
 * 如果传了就把视频绑定到对应的 <video> 标签上
 * @param pInfo:String 多媒体流附加信息，可选，默认为 'none'
 * @return src:String 视频预览地址
 */
export const initPullFlow = async (streamId, domId, muteAudio, pInfo, notAutoPlay, muteVideo) => {
  defaultApi.writeLog(`TALRTC::initPullFlow_start , streamId :${streamId}, notAutoPlay: ${notAutoPlay}, audioOnly: ${muteVideo}`);
  resetStreamIdRtcPlayerInfo1(streamId);
  resetStreamIdRtcPlayerInfo(streamId);
  try {
    if (!isFirstHeartBeatReport) {
      isFirstHeartBeatReport = true;
      heartBeatDataReport('start');
    }
  } catch (error) {}

  await startPlay(streamId, muteAudio, muteVideo);
  if (!notAutoPlay) {
    await startLocalOrRemotePreview(false, streamId, domId);
  }
  return {
    videoSrc: '',
    playerId: 0
  };
};

/**
 * @function 开始连麦
 * @param mode: number 采集器默认， 默认0=站立 1=坐立
 * @return Promise | void
 */
export const teacherStartLinkMic = async (mode = 0) => {
  await startMicrophone();
  if (mode === 0) {
    await muteLocalVideo(true, localStreamId);
    await setMicrophoneDevice({});
    // await muteStreamAudio(false);
    await muteLocalAudio(false);
  } else {
    // await muteLocalVideo(false, localStreamId);
    await muteLocalAudio(false);
  }
};


/**
 * @function 结束连麦
 * @param mode:number 采集器默认， 默认0=站立 1=坐立
 * @return Promise | void
 */
export const teacherStopLinkMic = async (mode = 0) => {
  await stopMicrophone();
  if (mode === 0) {
    await muteLocalAudio(true);
  } else {
    await setSystemAudioLoopback(false);
  }
};

/**
 * @function 停止拉所有的流
 * @return Promise | void
 */
const stopPlayAll = () => {
  return callMethod('StopPlayAll', {});
};

const playerSnapShot = async (streamId) => {
  defaultApi.writeLog(`avsdk TALRTC::playerSnapShot streamId: ${streamId}`);
  if (streamId === localStreamId) {
    return videoEncTrack.getCurrentFrameData();
  } else {
    return screenVideoTrack.getCurrentFrameData();
  }
};
/**
 * @function 切换播放流
 * @param streamId: String 需要停止流的 id，必选
 * @param toStreamId: String 被拉取的流的 id，必选
 * @param toDomId: String <video> 标签的 id，可选
 * @return Promise | void
 */
const changePullFlow = async (streamId, toStreamId, toDomId) => {
  await stopPlay(streamId);
  return initPullFlow(toStreamId, toDomId);
};

/**
 * @function 是否拉取音频流--通过播放器id控制
 * @param mute: Boolean，必选，true -> 不拉取，false -> 拉取，必选
 * @param playerId: Number，必选，播放器 id
 * @return Promise | void
 */
const pullAudioFlow = (streamId, mute) => {
  defaultApi.writeLog(`pullAudioFlow -- playerId ${playerId} operation ${mute} streamId ${streamid}`);
  if(streamid){
    if(streamIdToPreviewId[streamid] == undefined) {
      NOTICE.pullAudioFlowError({streamid});
      return;
    }else{
      playerId = streamIdToPreviewId[streamid];
      defaultApi.writeLog(`pullAudioFlow-playerId ${playerId}, ${JSON.stringify(streamIdToPreviewId)}`);
    }
  }
  try {
    streamIdRtcPlayerInfo1[streamId].audio_type = !mute;
  } catch (e) {
    defaultApi.writeLog(`pullAudioFlow ::streamIdRtcPlayerInfo1--error ${JSON.stringify(e)}`, null, 'error');
  }
  try {
    dataReport.setPullVoice({
      code: +!mute,
      pull_uid: util.getUidByStreamId(streamId),
      pull_streamid: streamId,
      playerId
      // operator:'client'
    });
  } catch (e) { };
  return muteRemoteAudio(streamId, mute);
};

/**
  * @function 设置镜像状态(预览)
  * @param { 0 | 1 | 2 | 3 } mode 0: 预览启用镜像，推流不启用镜像; 1: 预览启用镜像，推流启用镜像; 2: 预览不启用镜像，推流不启用镜像; 3: 预览不启用镜像，推流启用镜像
  * @return {Promise}
  */
const setMirrorStatus = (mode) => {
  const realId = mode == 0 ? 2 : 1;
  defaultApi.writeLog(`avsdk TALRTC::setMirrorStatus, mode: ${mode}, streamId:${localStreamId}, realId:${realId}`);
  return callMethod('SetMirrorStatus', { mode: realId, streamId: localStreamId });
};

/**
  * @function 设置拉流镜像状态
  * @param { boolean } type true=开启 false=关闭
  * @return: Promise
  */
const setPlayViewMirror = (isMirror, id) => {
  return callMethod('SetPlayViewMirror', { isMirror, streamId: id });
};

/**
 * @function 停止拉音频流
 * @param {string} streamId
 * @param {boolean} mute
 * @return {Promise<void>}
 */
const setAudioMuted = async (streamId, mute) => {
  if (streamId.split('_').length === 4) {
    await muteRemoteAudio(streamId, mute);
  } else if (streamId.split('_').length === 5) {
    await muteRemoteScreenAudio(streamId, mute);
  } else {
    const msg = `invalid streamId: ${streamId}`;
    reporter.sdkProbe('talrtc::setAudioMuted', msg);
    return Promise.reject(new Error(`avsdk TALRTC::setAudioMuted - ${msg}`));
  }
};

/**
 * @function 停止拉视频流
 * @param {string} streamId
 * @param {boolean} mute
 * @return {Promise<void>}
 */
const setVideoMuted = async (streamId, mute) => {
  if (streamId.split('_').length === 4) {
    await muteRemoteVideo(streamId, mute);
  } else if (streamId.split('_').length === 5) {
    await muteRemoteScreenVideo(streamId, mute);
  } else {
    const msg = `invalid streamId: ${streamId}`;
    reporter.sdkProbe('talrtc::setVideoMuted', msg);
    return Promise.reject(new Error(`avsdk TALRTC::setVideoMuted - ${msg}`));
  }
};

/**
 * @function 不拉/拉 音频
 * @param {string} streamId
 * @param {boolean} mute
 * @return Promise | void
 */
const muteRemoteAudio = async (streamId, mute) => {
  defaultApi.writeLog(`avsdk TALRTC::muteRemoteAudio - streamId: ${streamId}, mute: ${mute}`);
  const [, roomId, userId] = streamId.split('_');
  const numberUserId = formatUserId(userId);

  const client = clients.get(roomId);
  const user = users.get(`${roomId}_${numberUserId}`);

  if (!client) {
    defaultApi.writeLog(`avsdk TALRTC::muteRemoteAudio - no client found ${roomId}`, null, 'error');
    throw new Error(`avsdk TALRTC::muteRemoteAudio - no client found ${roomId}`);
  }

  if (!user) {
    defaultApi.writeLog(`avsdk TALRTC::muteRemoteAudio - no user found ${roomId}`);
    users.set(`${roomId}_${numberUserId}`, new User(!mute, false, userId));
    return;
  }

  user.userId = userId;
  user.subAudio = !mute;

  if (!user.rtcUser || !user.rtcUser.hasAudio) {
    defaultApi.writeLog(`avsdk TALRTC::muteRemoteAudio - user:${userId} has not be published`);
    return;
  }

  if (mute) {
    await client.unsubscribe(user.mainStreamId, 'audio');
  } else {
    const track = await client.subscribe(user.mainStreamId, 'audio');
    track.setVolume(speakerVolume);
    track.once('first-frame-decoded', () => {
      NOTICE.firstAudioSize({
        streamId,
        userId,
      });
    });
    track.play();
  }
};

/**
 * @function 不拉/拉 视频
 * @param {string} streamId
 * @param {boolean} mute
 * @return Promise | void
 */
const muteRemoteVideo = async (streamId, mute) => {
  defaultApi.writeLog(`avsdk TALRTC::muteRemoteVideo - streamId: ${streamId}, mute: ${mute}`);
  const [, roomId, userId] = streamId.split('_');
  const numberUserId = formatUserId(userId);

  const client = clients.get(roomId);
  const user = users.get(`${roomId}_${numberUserId}`);

  if (!client) {
    defaultApi.writeLog(`avsdk TALRTC::muteRemoteVideo - no client found ${roomId}`, null, 'error');
    throw new Error(`avsdk TALRTC::muteRemoteVideo - no client found ${roomId}`);
  }

  if (!user) {
    defaultApi.writeLog(`avsdk TALRTC::muteRemoteVideo - no user found ${roomId}`);
    users.set(`${roomId}_${numberUserId}`, new User(false, !mute, userId));
    return;
  }

  user.userId = userId;
  user.subVideo = !mute;

  if (!user.rtcUser || !user.rtcUser.hasVideo) {
    defaultApi.writeLog(`avsdk TALRTC::muteRemoteVideo - user:${userId} has not be published`);
    return;
  }

  if (mute) {
    user.rtcUser.videoTrack && user.rtcUser.videoTrack.stop();
    await client.unsubscribe(user.mainStreamId, 'video');
  } else {
    const track = await client.subscribe(user.mainStreamId, 'video');
    track.once('first-frame-decoded', () => {
      NOTICE.firstVideoSize({
        streamId,
        userId,
      });
    });
    if (user.videoDomId) {
      track.play(user.videoDomId, { fit: 'contain' });
    }
  }
};

/**
 * @function 不拉/拉 屏幕流音频
 * @param {string} streamId
 * @param {boolean} mute
 * @return Promise | void
 */
const muteRemoteScreenAudio = async (streamId, mute) => {
  defaultApi.writeLog(`avsdk TALRTC::muteRemoteScreenAudio - streamId: ${streamId}, mute: ${mute}`);
  const [, roomId, userId] = streamId.split('_');
  const numberUserId = formatUserId(userId);

  const client = clients.get(roomId);
  const user = users.get(`${roomId}_${numberUserId}`);

  if (!client) {
    defaultApi.writeLog(`avsdk TALRTC::muteRemoteScreenAudio - no client found ${roomId}`, null, 'error');
    throw new Error(`avsdk TALRTC::muteRemoteScreenAudio - no client found ${roomId}`);
  }

  if (!user) {
    defaultApi.writeLog(`avsdk TALRTC::muteRemoteScreenAudio - no user found ${roomId}`);
    users.set(`${roomId}_${numberUserId}`, new User(false, false, userId).subScreenAudio = !mute);
    return;
  }

  user.userId = userId;
  user.subScreenAudio = !mute;

  if (!user.rtcUser || !user.rtcUser.hasScreen) {
    defaultApi.writeLog(`avsdk TALRTC::muteRemoteScreenAudio - user:${userId} has not be published`);
    return;
  }

  if (mute) {
    await client.unsubscribe(user.screenStreamId, 'audio');
  } else {
    const track = await client.subscribe(user.screenStreamId, 'audio');
    track.setVolume(speakerVolume);
    track.once('first-frame-decoded', () => {
      NOTICE.firstAudioSize({
        streamId,
        userId,
      });
    });
    track.play();
  }
};
/**
 * @function 不拉/拉 屏幕流视频
 * @param {string} streamId
 * @param {boolean} mute
 * @return Promise | void
 */
const muteRemoteScreenVideo = async (streamId, mute) => {
  defaultApi.writeLog(`avsdk TALRTC::muteRemoteScreenVideo - streamId: ${streamId}, mute: ${mute}`);
  const [, roomId, userId] = streamId.split('_');
  const numberUserId = formatUserId(userId);

  const client = clients.get(roomId);
  const user = users.get(`${roomId}_${numberUserId}`);

  if (!client) {
    defaultApi.writeLog(`avsdk TALRTC::muteRemoteScreenVideo - no client found ${roomId}`, null, 'error');
    throw new Error(`avsdk TALRTC::muteRemoteScreenVideo - no client found ${roomId}`);
  }

  if (!user) {
    defaultApi.writeLog(`avsdk TALRTC::muteRemoteScreenVideo - no user found ${roomId}`);
    users.set(`${roomId}_${numberUserId}`, new User(false, false, userId).subScreenVideo = !mute);
    return;
  }

  user.userId = userId;
  user.subScreenVideo = !mute;

  if (!user.rtcUser || !user.rtcUser.hasScreen) {
    defaultApi.writeLog(`avsdk TALRTC::muteRemoteScreenVideo - user:${userId} has not be published`);
    return;
  }

  if (mute) {
    user.rtcUser.screenTrack && user.rtcUser.screenTrack.stop();
    await client.unsubscribe(user.screenStreamId, 'video');
  } else {
    const track = await client.subscribe(user.screenStreamId, 'video');
    track.once('first-frame-decoded', () => {
      NOTICE.firstVideoSize({
        streamId,
        userId,
      });
    });
    if (user.screenDomId) {
      track.play(user.screenDomId, { fit: 'contain' });
    }
  }
};
//开启同屏
const startMultiScreen = async () => {
  defaultApi.writeLog('info', 'avsdk TALRTC::startMultiScreen');
  // await enableExternalVideoSource(true,1);
  await LoadCollectionOutputEntry2();
};

/**
 * @function 离开教室
 * @return Promise | void
 */
const leaveRoom = async (isChangeSDK) => {
  if (!isChangeSDK) {
    globalVariables.localPreviewDomId = null;
  }
  for (let key in streamIdToPreviewId) {
    stopPlay(key, true);//huishou
  }

  await stopPush(localStreamId);
  stopCamera();
  stopMicrophone();
  stopScreenCapture();

  clearInterval(micVolTimer);
  clearInterval(remoteVolTimer);
  screenPreviewDomId = null;
  localStreamId = null;
  screenStreamId = null;
  // removerListener();
  destroyEngine();
  heartBeatDataReport('stop');
  // isFirstHeartBeatReport = false;
  streamIdToPreviewId = {};
  previewIdToStreamId = {};
  streamIdRtcPlayerInfo = {};
  streamIdRtcPlayerInfo1 = {};
};


/**
 * @function 卸载 Talrtc 扩展
 * @return Promise | void
 */
export const unloadTalrtc = () => {
  // EM 是寄宿于端的，浏览器中并不存在，为防止报错需要先进行能力检测
  if (EM) {
    return new Promise((resolve, reject) => {
      EM.UnLoad(
        extensionId,
        (code, msg) => {
          defaultApi.writeLog(`unloadTalrtc Code: ${code}\nMessage: ${msg}`);
          resolve();
        }
      );
    });
  }
};

/**
 * @function 本地录制
 * @param {string | undefined} fileName 
 * @param {number} fileType 1:flv 2:mp4
 * @param {number} idx 0:主流 1:辅流 2:RTMP流
 * @returns {Promise<any>}
 */
export const startRecord = async (fileName, fileType, idx) => {
  const streamId = [localStreamId, screenStreamId, 'rtmp'][idx];
  defaultApi.writeLog(`avsdk TALRTC::startRecord fileName: ${fileName}, fileType: ${fileType}, idx: ${idx}, streamId: ${streamId}`);
  if (idx === 1 && !screenStreamId) {
    defaultApi.writeLog('avsdk TALRTC::startRecord screenStreamId is null', null, 'error');
    return;
  }
  if (!fileName) {
    fileName = `${streamId}-${util.currentTimeString().replace(/:/g, '-')}`;
  }
  dataReport.startRecord({fileName, fileType, idx, streamId});
  return callMethod('StartRecord', {
    streamId,
    recordType: 3, // 1:音频 2:视频 3:音视频
    fileName,
    recordFormat: fileType,
  });
};
/**
 * 结束音视频录制 channelIndex(number) 录制通道  0主推流通道/ 1辅助推流通道/ 2辅助推流通道
 * @param {number} idx 0 | 1 | 2
 * @returns 
 */
export const stopRecord = async (idx) => {
  const streamId = [localStreamId, screenStreamId, 'rtmp'][idx];
  defaultApi.writeLog(`avsdk TALRTC::stopRecord idx: ${idx}, streamId: ${streamId}`);

  dataReport.stopRecord({idx, streamId});
  return callMethod('StopRecord',{streamId});
};
/**
 * 开启外部音频采集（通知sdk）推流前，调用此接口，publish_channel，number类型，传2代表第三路流
 * @param {number} idx 0 | 1 | 2
 * @returns 
 */
export const startCapture = async (idx) => {
  const streamId = [localStreamId, screenStreamId, 'rtmp'][idx];
  defaultApi.writeLog(`avsdk TALRTC::startCapture idx: ${idx}, streamId: ${streamId}`);

  return callMethod('StartCapture',{streamId});
};
/**
 * 结束外部音频采集（通知sdk）
 * @param {number} idx 0 | 1 | 2
 * @returns 
 */
export const stopCapture = async (idx) => {
  const streamId = [localStreamId, screenStreamId, 'rtmp'][idx];
  defaultApi.writeLog(`avsdk TALRTC::stopCapture idx: ${idx}, streamId: ${streamId}`);

  return callMethod('StopCapture',{streamId});
};

const heartBeatRealKeys = ['video_fps', 'video_bitrate', 'audio_fps', 'audio_bitrate'];

const _heartBeatDataReport = () => {
  const pullInfo = [];
  console.log('拉流的类型1',streamIdRtcPlayerInfo);
  Object.keys(streamIdRtcPlayerInfo).forEach(streamid => {
    heartBeatRealKeys.forEach(realKey => {
      if (!streamIdRtcPlayerInfo[streamid].hasOwnProperty(realKey)) {
        streamIdRtcPlayerInfo[streamid][realKey] = [];
      }
      // if (streamIdRtcPlayerInfo[streamid].count > 0) {
      //   streamIdRtcPlayerInfo[streamid][realKey] = util.toFixed(streamIdRtcPlayerInfo[streamid][realKey]/streamIdRtcPlayerInfo[streamid].count);
      // }
    });
    //获取拉流类型，后期可写为函数提出去
    if(streamIdRtcPlayerInfo1[streamid].audio_type && streamIdRtcPlayerInfo1[streamid].video_type) {
      streamIdRtcPlayerInfo1[streamid].stream_type = 'both';
    } else if(!streamIdRtcPlayerInfo1[streamid].audio_type && streamIdRtcPlayerInfo1[streamid].video_type) {
      streamIdRtcPlayerInfo1[streamid].stream_type = 'video';
    } else if(streamIdRtcPlayerInfo1[streamid].audio_type && !streamIdRtcPlayerInfo1[streamid].video_type) {
      streamIdRtcPlayerInfo1[streamid].stream_type = 'audio';
    } else {
      streamIdRtcPlayerInfo1[streamid].stream_type = 'none';
    }
    // console.log('hsghsghsg_type_type', streamIdRtcPlayerInfo1[streamid].stream_type);

    pullInfo.push({
      streamid,
      // uid: util.getUidByStreamId(streamid),
      ...streamIdRtcPlayerInfo[streamid],
      pull_type: streamIdRtcPlayerInfo1[streamid].stream_type,
      volume: streamIdRtcPlayerInfo[streamid].volume.slice(0,streamIdRtcPlayerInfo[streamid].volume.length-1)
    });
    resetStreamIdRtcPlayerInfo(streamid);
  });
  if (isFirstHeartBeatReport) {
    try {
      //静音推流时过滤掉音频帧率和码率，上报为0；
      // if (!isNoticeMicVolumeZego) {
      //   heartBeatDataReportObj['audio_fps'] = [];
      //   heartBeatDataReportObj['audio_bitrate'] = [];
      // }

      //获取推流类型，后期可写为函数提出去
      if(window.zbztsdk.deviceStatus.camera && window.zbztsdk.deviceStatus.microphone) {
        window.zbztsdk.deviceStatus.stream_type = 'both';
      } else if(!window.zbztsdk.deviceStatus.camera && window.zbztsdk.deviceStatus.microphone) {
        window.zbztsdk.deviceStatus.stream_type = 'audio';
      } else if(window.zbztsdk.deviceStatus.camera && !window.zbztsdk.deviceStatus.microphone) {
        window.zbztsdk.deviceStatus.stream_type = 'video';
      } else {
        window.zbztsdk.deviceStatus.stream_type = 'none';
      };
      // console.log('push_type222',window.zbztsdk.deviceStatus,window.zbztsdk.deviceStatus.stream_type);
      defaultApi.writeLog(`push_type_talrtc,camera: ${window.zbztsdk.deviceStatus.camera},microphone: ${window.zbztsdk.deviceStatus.microphone},type: ${window.zbztsdk.deviceStatus.stream_type},a_fps: ${dataTalrtcCapture.fps}, a_bit: ${dataTalrtcCapture.audioBitrate}, v_fps: ${dataTalrtcCapture.fps}, v_bit: ${dataTalrtcCapture.videoBitrate}`);
      // if (window.zbztAVSDK_init_params.zego.role === 'teacher') {
      dataReport.heartbeat({
        ...{...heartBeatDataReportObj, push_type: window.zbztsdk.deviceStatus.stream_type, volume: heartBeatDataReportObj.volume.slice(0,heartBeatDataReportObj.volume.length-1)},
        // pull_info: JSON.stringify(pullInfo),
        pull_info: pullInfo,
        // cpu_rate: util.toFixed(cpuRate/rateCount),
        // mem_rate: util.toFixed(memRate/rateCount),
      });
      // } else {
      //   dataReport.heartbeat({
      //     ...heartBeatDataReportObj,
      //     pull_info: JSON.stringify(pullInfo),
      //     cpu_rate: util.toFixed(cpuRate/rateCount),
      //     mem_rate: util.toFixed(memRate/rateCount),
      //     app_cpu: util.toFixed(appCpuRate/rateCount),
      //     app_mem: util.toFixed(appMemUsed/rateCount),
      //     video_mem: gpus
      //   });
      // }
      dataReport.localNetworkQuality({
        code:  qualityLocal,
      });
      dataReport.remoteNetworkQuality({
        code:  qualityRemote,
      });
    } catch (e) {
      console.log(e);
    }
  }
  resetHeartBeatDataReportObj();
  // cpuRate = 0;
  // memRate = 0;
  // appCpuRate = 0;
  // appMemUsed = 0;

  // clearInterval(rateTimer);
  // }
  // }, 10 * 1000);
};

const heartBeatDataReport = (type) => {
  try {
    if (type === 'start' && !heartBeatDataReportTimer) {
      console.log('start heart beat report');
      _heartBeatDataReport();
      heartBeatDataReportTimer = setInterval(() => {
        _heartBeatDataReport();
      }, 30 * 1000);
    }
    if (type === 'stop') {
      clearInterval(heartBeatDataReportTimer);
      heartBeatDataReportTimer = null;
    }
  } catch (error) {
    console.log(error);
  }
};
const lastStreamReportTimestamps = {};

const heartBeatDataReportCalc = (name, _data) => {
  let _d = JSON.parse(_data.stats);

  if (lastStreamReportTimestamps[_d.streamId] && Date.now() - lastStreamReportTimestamps[_d.streamId] < 4999) {
    return;
  } else {
    lastStreamReportTimestamps[_d.streamId] = Date.now();
  }
  // 拉流
  const pullKeys = ['fps', 'videoBitrate', 'afps', 'audioBitrate'];
  if (name === 'onRemoteStatistics') {
    if (streamIdRtcPlayerInfo && streamIdRtcPlayerInfo.hasOwnProperty(_d.streamId)) {
      let streamid = _d.streamId;
      let isReport = true;
      // streamIdRtcPlayerInfo[streamid].count++;
      heartBeatRealKeys.forEach((realKey, index) => {
        if (_d.hasOwnProperty(pullKeys[index])) {
          if (streamIdRtcPlayerInfo[streamid][realKey] === undefined) {
            streamIdRtcPlayerInfo[streamid][realKey] = [];
            isReport = false;
          }
          // streamIdRtcPlayerInfo[streamid][realKey].push(parseFloat(parseInt(item[pullKeys[index]])));
        }
      });
      if (isReport) {
        let audio_fps_talrtc_pull = 0;
        let audio_bitrate_talrtc_pull = 0;
        let video_fps_talrtc_pull = 0;
        let video_bitrate_talrtc_pull = 0;
        if(streamIdRtcPlayerInfo1[streamid].audio_type && streamIdRtcPlayerInfo1[streamid].video_type) {
          audio_fps_talrtc_pull = parseFloat(parseInt(_d.afps));
          audio_bitrate_talrtc_pull = parseFloat(parseInt(_d.audioBitrate));
          video_fps_talrtc_pull = parseFloat(parseInt(_d.fps));
          video_bitrate_talrtc_pull = parseFloat(parseInt(_d.videoBitrate));
        } else if(!streamIdRtcPlayerInfo1[streamid].audio_type && streamIdRtcPlayerInfo1[streamid].video_type) {
          video_fps_talrtc_pull = parseFloat(parseInt(_d.fps));
          video_bitrate_talrtc_pull = parseFloat(parseInt(_d.videoBitrate));
        } else if(streamIdRtcPlayerInfo1[streamid].audio_type && !streamIdRtcPlayerInfo1[streamid].video_type) {
          audio_fps_talrtc_pull = parseFloat(parseInt(_d.afps));
          audio_bitrate_talrtc_pull = parseFloat(parseInt(_d.audioBitrate));
        }
        streamIdRtcPlayerInfo[streamid].audio_fps.push(audio_fps_talrtc_pull);
        streamIdRtcPlayerInfo[streamid].audio_bitrate.push(audio_bitrate_talrtc_pull);
        streamIdRtcPlayerInfo[streamid].video_fps.push(video_fps_talrtc_pull);
        streamIdRtcPlayerInfo[streamid].video_bitrate.push(video_bitrate_talrtc_pull);
        streamIdRtcPlayerInfo[streamid].pull_loss.push(_d.packetLoss);
        streamIdRtcPlayerInfo[streamid].pull_delay.push(_d.rtt);

        streamIdRtcPlayerInfo[streamid].ctime.push(Math.round((new Date().getTime()+dataReport.timestamp)/1000));
        streamIdRtcPlayerInfo[streamid].video_ifg += _d.videoBlockRate;
        streamIdRtcPlayerInfo[streamid].audio_ifg += _d.audioBlockRate;
        // console.log('hsg_tpull_keys',JSON.parse(JSON.stringify(streamIdRtcPlayerInfo[streamid])),_d.avTimestampDiff);
      }
    }
  }
  // 推流
  const pushKeys = ['fps', 'videoBitrate', 'afps', 'audioBitrate'];
  if (name === 'onLocalStatistics') {
    // console.log('hsgmzk',_d);
    // heartBeatDataReportObj.count++;
    // heartBeatRealKeys.forEach((realKey, index) => {
    //   if (heartBeatDataReportObj.hasOwnProperty(realKey) && _d.hasOwnProperty(pushKeys[index])) {
    //     heartBeatDataReportObj[realKey].push(parseFloat(parseInt(_d[pushKeys[index]])));
    //   }
    // });
    let audio_fps_talrtc_push = 0;
    let audio_bitrate_talrtc_push = 0;
    let video_fps_talrtc_push = 0;
    let video_bitrate_talrtc_push = 0;
    dataTalrtcCapture =_d;

    if(window.zbztsdk.deviceStatus.camera && window.zbztsdk.deviceStatus.microphone) {
      audio_fps_talrtc_push = parseFloat(parseInt(_d.afps));
      audio_bitrate_talrtc_push = parseFloat(parseInt(_d.audioBitrate));
      video_fps_talrtc_push = parseFloat(parseInt(_d.fps));
      video_bitrate_talrtc_push= parseFloat(parseInt(_d.videoBitrate));
    } else if(!window.zbztsdk.deviceStatus.camera && window.zbztsdk.deviceStatus.microphone) {
      audio_fps_talrtc_push = parseFloat(parseInt(_d.afps));
      audio_bitrate_talrtc_push = parseFloat(parseInt(_d.audioBitrate));
    } else if(window.zbztsdk.deviceStatus.camera && !window.zbztsdk.deviceStatus.microphone) {
      video_fps_talrtc_push = parseFloat(parseInt(_d.fps));
      video_bitrate_talrtc_push = parseFloat(parseInt(_d.videoBitrate));
    }
    heartBeatDataReportObj.audio_fps.push(audio_fps_talrtc_push);
    heartBeatDataReportObj.audio_bitrate.push(audio_bitrate_talrtc_push);
    heartBeatDataReportObj.video_fps.push(video_fps_talrtc_push);
    heartBeatDataReportObj.video_bitrate.push(video_bitrate_talrtc_push);
    heartBeatDataReportObj.push_loss.push(_d.packetLoss);
    heartBeatDataReportObj.push_delay.push(_d.rtt);
    heartBeatDataReportObj.ctime.push(Math.round((new Date().getTime()+dataReport.timestamp)/1000));
  }
};

//推流字段
const resetHeartBeatDataReportObj = () => {
  console.log('resetHeartBeatDataReportObj重置');
  heartBeatDataReportObj = {
    ctime: [],
    push_type: 'none',
    video_fps: [],
    video_bitrate: [],
    audio_fps: [],
    audio_bitrate: [],
    push_loss: [],
    push_delay: [],
    volume: ''
  };
};

resetHeartBeatDataReportObj();
//记录拉流类型，用作数据上报
const resetStreamIdRtcPlayerInfo1 = (streamId) => {
  streamIdRtcPlayerInfo1[streamId] = {
    audio_type: false,
    video_type: false,
    stream_type: 'none'
  };
  // console.log('hsgshgs_heartbeat',streamIdRtcPlayerInfo1);
};
//拉流字段
const resetStreamIdRtcPlayerInfo = (streamId) => {
  console.log('reset stream info ----------', streamId);
  streamIdRtcPlayerInfo[streamId] = {
    pull_uid: util.getUidByStreamId(streamId),
    streamid: streamId,
    ctime: [],
    pull_type: streamIdRtcPlayerInfo1[streamId].stream_type,
    volume: '',
    // 平均值
    // count: 0,
    // video_fps: 0,
    // video_bitrate: 0,
    // audio_fps: 0,
    // audio_bitrate: 0,
    video_fps: [],
    video_bitrate: [],
    audio_fps: [],
    audio_bitrate: [],
    pull_loss: [],
    pull_delay: [],
    //音画不同步字段
    avtimestampdiff: [],
    // 累加
    audio_ifg: 0,
    video_ifg: 0
  };

  console.log('reset stream info ----------', streamId, streamIdRtcPlayerInfo[streamId]);
};

export default {
  init,
  setCameraCaptureResolution,
  setCameraEncodeResolution,
  setCameraEncodeFps, // 未实现调用
  setCameraEncodeBitrate,
  getCameraResolution,
  getMicrophoneDeviceList,
  setMicrophoneDevice,
  openOrCloseMicrophone,
  getCameraDeviceList,
  setCameraDevice,
  openOrCloseCamera,
  getSpeakerDeviceList,
  setSpeakerDevice,
  getCurrentSpeakerDevice,
  getCurrentSpeakerVolume,
  setCurrentSpeakerVolume,
  setSpeakerDeviceMute,
  setAudioMuted,
  setVideoMuted,
  muteRemoteAudio,
  muteRemoteVideo,
  getSpeakerSimpleVolume,
  setSpeakerSimpleVolume,
  setSpeakerSimpleMute,
  setCurrentMicrophoneVolume,
  getCurrentMicrophoneVolume,
  startLocalOrRemotePreview,
  restartCaptureScreen,
  getScreenType,
  startDeviceCheckerPreview,
  stopDeviceCheckerPreview,
  enableAudioSpeakerCapture,
  startPush,
  stopPush,
  startPlay,
  stopPlay,
  initPullFlow,
  stopPlayAll,
  playerSnapShot,
  changePullFlow,
  sendSEIMsg,
  controlCdnStreaming, // addPublishRtmpStreamUrl or removePublishStreamUrl
  leaveRoom,
  destroyEngine,
  unloadTalrtc,
  muteLocalVideo,
  muteLocalAudio,
  pullAudioFlow,
  hasStream,
  teacherStartLinkMic,
  teacherStopLinkMic,
  setMirrorStatus,
  setPlayViewMirror,
  startMultiScreen,
  startRecord,
  stopRecord,
  startCapture,
  stopCapture,
  getChannelIndex,
  getSDKVersion
};
